module.exports = __webpack_public_path__ + "files/771b8b457d1492a141f71e79fc867d98.png";